import { memo } from "react";
import { EditPickupPartnerRow } from "./EditPickupPartnerRow";
import { View } from "../../Base";

export const EditPickupContent = memo(
  ({ routeEdit, pickupModalConfig, onEdit }) => (
    <View>
      {pickupModalConfig
        .filter(({ hide }) => !hide)
        .map(({ key, label, value, config }) => (
          <EditPickupPartnerRow
            key={key}
            label={label}
            value={value}
            config={config}
            routeEdit={routeEdit}
            onEdit={() => onEdit(key)}
          />
        ))}
    </View>
  )
);
